import { render, staticRenderFns } from "./HistorySabbatical.vue?vue&type=template&id=2edd7ba9&scoped=true&"
import script from "./HistorySabbatical.vue?vue&type=script&lang=js&"
export * from "./HistorySabbatical.vue?vue&type=script&lang=js&"
import style0 from "./HistorySabbatical.vue?vue&type=style&index=0&id=2edd7ba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd7ba9",
  null
  
)

export default component.exports